import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../config";
import useCasinoType from "../../hook/useCasinoType";
import { useLocation } from "react-router";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const CommonHelmet = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`seo.home.${key}`, { ...props });

  return process.env.REACT_APP_DEVELOP_MODE == 1 ? null : (
    <Helmet htmlAttributes={{ lang: i18next.language }}>
      <meta charSet="utf-8" />
      <meta property="og:description" content={appName} />
      <meta property="og:title" content={appName} />
      <meta property="og:url" content={window.location.origin} />
      <link
        rel="icon"
        href={`${process.env.REACT_APP_I18N_PATH}/logo/logo_144.png?ddd`}
      />
      <link
        rel="apple-touch-icon"
        href={`${process.env.REACT_APP_I18N_PATH}/logo/logo_144.png?ddd`}
      />
      <link rel="canonical" href={window.location.origin} />
      <link
        href="https://fonts.cdnfonts.com/css/berlin-sans-fb-demi"
        rel="stylesheet"
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Noto+Sans+TC:wght@100..900&family=Oxygen:wght@300;400;700&family=Passion+One:wght@400;700;900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        rel="stylesheet"
      />

      <title lang={i18next.language}>{i18n("title", { appName })}</title>
      <meta lang={i18next.language} content={i18n("meta1", { appName })} />
    </Helmet>
  );
};

export default CommonHelmet;
